import React from 'react';
import cn from 'classnames';

import VIDEO_TUT from 'assets/videos/Email_Marketing_Flow_v1.mp4';
import ExternalLink from 'components/generic/ExternalLink.component';
import Icon from 'components/generic/Icon.component';
import Video from 'components/generic/Video.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import CN from './EmailsInfo.module.scss';

const LINK_HOW_TO_START = 'https://help.getslick.com/en/articles/12975056-slick-email-quick-guide';
const LINK_DESIGN_EMAILS = 'https://help.getslick.com/en/articles/12975570-how-to-design-emails-on-slick-email';

const EmailsInfo = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  return (
    <div
      data-bem="EmailsInfo"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.container}>
        <div data-bem="EmailsInfo__video" className={CN.infoVideo}>
          <Video src={VIDEO_TUT} title={t('clientsEmailPage.emailsInfo.videoTitle')} variant="full" />
        </div>
        <div data-bem="EmailsInfo__info" className={CN.infoBlock}>
          <div className={CN.infoTitle}>{t('clientsEmailPage.emailsInfo.description')}</div>
          <div className={CN.point}>
            <Icon variant="checkCircle" width="md" />
            {t('clientsEmailPage.emailsInfo.bullet1')}
          </div>
          <div className={CN.point}>
            <Icon variant="checkCircle" width="md" />
            <div>
              <span className={CN.bold}>{t('clientsEmailPage.emailsInfo.bullet2.part1')} </span>
              {t('clientsEmailPage.emailsInfo.bullet2.part2')} <CurrencySign />
              {t('clientsEmailPage.emailsInfo.bullet2.part3')}
            </div>
          </div>
          <div className={CN.point}>
            <Icon variant="checkCircle" width="md" />
            {t('clientsEmailPage.emailsInfo.bullet3')}
          </div>

          <div className={CN.linkContainer}>
            <ExternalLink tag="EmailsInfo__link" link={LINK_HOW_TO_START}>
              <span className={CN.articleLink}>{t('clientsEmailPage.emailsInfo.howToStartLink')}</span>
            </ExternalLink>
            <ExternalLink tag="EmailsInfo__link" link={LINK_DESIGN_EMAILS}>
              <span className={CN.articleLink}>{t('clientsEmailPage.emailsInfo.templatesLink')}</span>
            </ExternalLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailsInfo;
